/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import datos from "../../assets/items_arnes_produced.json"


// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import IconButton from '@mui/material/IconButton';
import Icon from "@mui/material/Icon";
import ConfirmDialog from "components/ConfirmDialog";
import TableSkeleton from "components/TableSkeleton";
import CustomAlert from "components/CustomAlert";
import TokenApi from "components/TokenApi";
import CustomInput from "components/MDInputField/CustomInput";
import DinamicDate from "components/DinamicDateFields";
import CircularProgress from '@mui/material/CircularProgress';
import TextField from "@mui/material/TextField";
import Backdrop from "@mui/material/Backdrop";
import axios from 'axios';

// Data
import { useEffect, useState, useMemo } from "react";
import { RoleAPI } from "api/RoleAPI";
import { ProarnesAPI } from "api/ProarnesAPI";
import { ImagenComponentAPI } from "api/ImagenComponentAPI";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import permissions from "permissions";


function ImageComponents() {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state;
  const [roles, setRoles] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [id, setId] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const { user, loading, admin } = controller;
  const [formData, setFormData] = useState({});
  const [fields, setFields] = useState([]);


  const [archivo, setArchivo] = useState(null);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });

  const BASE_URL = process.env.REACT_APP_API_YEMINUS;
  const USER_PASSWORD = process.env.REACT_APP_PASS_YEMINUS;
  const { token, authenticate, COMPANY_ID, USER_ID } = TokenApi();

  const [searchTerm, setSearchTerm] = useState("");
  const [originalRows, setOriginalRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  
  const handleFileUpload = (file) => {
    setArchivo(file); 
    console.log("Archivo seleccionado:", file);
  };



  const productos = datos;
 

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  // buscador
  
  useEffect(() => {
    if (searchTerm === "") {
      setFilteredRows(originalRows);
    } else {
      const filtered = originalRows.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setFilteredRows(filtered);
    }
  }, [searchTerm, originalRows]);
  
  // buscador

  useEffect(() => {
    setTableData((prev) => ({
      ...prev,
      rows: filteredRows,
    }));
  }, [filteredRows]);


  useEffect(() => {
    const fetchToken = async () => {
      await authenticate(); 
    };
  
    fetchToken();
  }, []);



const handleInputChange = (e) => {
  console.log(e.target.value);
  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });
};


  const handleAlertClose = () => setAlert(false);

  const handleClick = () => {
    navigate('create');
  }

  const handleDelete = (id) => {
    setId(id)
    setIsDeleting(true);
  }

  const handleCancelDelete = () => {
    setIsDeleting(false);
  };

  const handleConfirmDelete = () => {
    return deleteRole(id)
  };

 

  const deleteRole = (id) => {
    return RoleAPI.delete(id)
      .then(response => {
        const updatedRoles = roles.filter((role) => role.id !== response.role);
        setRoles(updatedRoles);
        handleAlert(response.message, 'success');
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        handleCancelDelete();
      });
  }

  const getRoles = (signal) => {
    return RoleAPI.index(signal)
      .then(response => {
        setRoles(response.roles)
      }).catch(error => {
        if (error.response)
          handleAlert(error.response.data.message, 'error')
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  //to storage imagen componentent

  const handleFile = () => {

    if (!archivo) {
      handleAlert(`Por favor, cargue una imagen para proceder .`, "error");
      return;
    }

      if (!formData.descripcion || !formData.codigo) {
        handleAlert("Por favor, complete todos los campos antes de continuar.", "error");
        return;
      }

      const formDataToSend = new FormData();
      formDataToSend.append("file", archivo);
      formDataToSend.append("descripcion", formData.descripcion);
      formDataToSend.append("codigo", formData.codigo);



      ImagenComponentAPI.imagecomponent(formDataToSend)
            .then((response) => {
            console.log("Respuesta del servidor:", response);

            if (response.status) {
              console.log("Archivo enviado con éxito a Cableado");
              handleAlert(response.message, "success");
              setFormData({ descripcion: "", codigo: "" });
              setArchivo(null);
            } else {
              console.error("Error en la respuesta:", response.message);
              handleAlert(response.message, "error");
            }
          })
          .catch((error) => {
            console.error("Error en la petición:", error);
            if (error.response) {
              handleAlert(error.response.data.message, "error");
            }
            }); 

  }

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);

 
  const fetchData = async () => {
    let currentToken = token;
  
    if (!currentToken) {
      currentToken = await authenticate();
    }
  
    if (!currentToken) {
      console.error("No se pudo obtener el token");
      return;
    }
  
    const headers = {
      Authorization: `Bearer ${currentToken}`,
      id_empresa: COMPANY_ID,
      usuario: USER_ID,
      "Content-Type": "application/json",
    };
  

  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            
            {/* <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', pb: 3 }}>
              {(user?.permissions?.includes(permissions.roles[1]) || user?.role === admin) && (
                <MDButton variant="gradient" color="info" onClick={handleClick}> Crear Rol</MDButton>
              )}
            </MDBox> */}
             

            <MDBox mb={4} px={2}>
              <CustomAlert severity="secondary" message="En este sitio se puede agregar componentes electricos junto con su imagen." open="true" onClose={handleAlertClose}></CustomAlert>
            </MDBox>

            <Card>

            
            <MDBox pt={5} mb={5} ml={4} display="flex" justifyContent="space-around" alignItems="center">
              {/* para botones de fechas */}
              <Grid item xs={12} sm={6} >
                <MDBox p={5} >
                  <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label="Descripción"
                          name="descripcion"
                          multiline
                          rows={4}
                          fullWidth
                          variant="outlined"
                          onChange={handleInputChange}
                          value={formData.descripcion || ""}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label="Codigo del componente"
                          name="codigo"
                          fullWidth
                          variant="outlined"
                          onChange={handleInputChange}
                          value={formData.codigo || ""}
                        />
                      </Grid>
                      <Grid item xs={12}>
                      <CustomInput accept=".jpg,.png" onFileSelect={handleFileUpload} />
                      </Grid>

                    </Grid>
                </MDBox>
              </Grid>
              {/* para botones de fechas */}

              {/* Contenedor del botón con flexbox para centrar */}
              <Grid item xs={12} sm={6} display="flex" justifyContent="center" alignItems="center">
                <MDButton
                  variant="gradient"
                  color="info"
                  size="medium"
                  sx={{
                    minWidth: "150px",
                    height: "45px",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "1rem",
                    mt: 2, // Margen superior
                  }}
                  onClick={handleFile}
                >
                  Guardar componente
                </MDButton>
              </Grid>
            </MDBox>


              <MDBox mt={5} mb={5}  display="flex" justifyContent="center">
              <MDBox width="50%">

              </MDBox>
            </MDBox>

              {archivo && (
                <MDBox mt={2} textAlign="center">
                  <MDTypography variant="body1">Archivo seleccionado: {archivo.name}</MDTypography>
                </MDBox>
              )}

            </Card>

            {isDeleting && (<ConfirmDialog onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} ></ConfirmDialog>)}
          </Grid>
        </Grid>

          {/* tabla para visualizar lo cargado de la respuseta del servidor */}
          <Grid container justifyContent="left" mt={4} pb={3}>
          <MDBox display="flex" justifyContent="flex-end" px={2} mb={2}>
          <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '300px',
              padding: '10px',
              fontSize: '16px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              outline: 'none',
              transition: '0.2s all ease',
            }}
            />
          </MDBox>
          </Grid>
          
          <Grid container justifyContent="center" mt={4} pb={3}>
            
            <MDBox sx={{ width: '100%' }}>
              {tableData.columns.length > 0 && (
                <Card sx={{ marginTop: '20px' }}>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Listado de arneses producidos en un rango de fechas
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={3}>
                    <DataTable
                      table={tableData}
                      isSorted={true}
                      entriesPerPage={true}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </Card>
              )}
            </MDBox>
          </Grid>

          {/* tabla para visualizar lo cargado */}


          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ImageComponents;